import React, { useEffect, useRef, useState } from "react";
import { Snackbar, Button, IconButton, Alert } from "@mui/material";

import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

function CircularProgressWithLabel(props) {
    return (
      <Box sx={{ position: 'relative', display: 'inline-flex', marginLeft: '10px'}}>
        <CircularProgress variant="determinate" size={26} thickness={2.5} color='inherit' {...props} />
        <Box
          sx={{
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            position: 'absolute',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography variant="caption" component="div" color="inherit" sx={{fontSize: 10}}>
            {`${props.label}`}
          </Typography>
        </Box>
      </Box>
    );
  }

const HidingError = ({...otherProps}) => {
    
    const [duration, setDuration] = useState(5000);
    const [left, setLeft] = useState(5000);
    const timer = useRef();

    const closeError = () => {  
        window.clearInterval(timer.current);
        setTimeout( () => otherProps.onClose(), 100);
        setTimeout( () => setLeft(duration), 200);
    };

    const countdown = () => {
        timer.current = window.setInterval(() => { 
            setLeft( (prev) => {
                if(prev) return (prev - 1000);
                else {
                    closeError();
                    return prev;
                }
            });
        }, 1000);
    };

    useEffect( () => { 
        if(otherProps.open) { 
            countdown();
        }
        return () => { 
            window.clearInterval(timer.current);
            setTimeout( () => setLeft(duration), 200);
        };
    }, [otherProps.open]);

    const handlePause = () => {
        window.clearInterval(timer.current);
    }
    const handleResume = () => { 
        if(otherProps.open) countdown();
    }

    return (
        <Snackbar
            {...otherProps}
            anchorOrigin={{vertical: 'top', horizontal: 'center'}}
            disableWindowBlurListener
            onMouseOver={handlePause}
            onMouseLeave={handleResume}
        >
            <Alert
                onClose={closeError}
                severity="error"
                sx={{width: '100%'}}
                variant="filled"                
            >
                <div style={{display: 'flex', alignItems: 'center'}}>
                    <div style={{display: "inline-block"}}>{`${otherProps.message}`}</div>
                    <CircularProgressWithLabel 
                        value={left/50}
                        label={ (left !== undefined) ? `${Math.floor(left/1000)}с` : ""}
                    />
                </div>
            </Alert>
              
        </Snackbar>
    );
}

export default HidingError;